export default function () {
    return function (seconds) {
        if (!seconds && seconds !== 0) {
            return '--:--:--';
        }

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        const pad = (num) => String(num).padStart(2, '0');

        return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
    };
}



// WEBPACK FOOTER //
// ./src/app/filters/secondsToTime/index.js